import React from "react";
import { withRouter } from "react-router";

const Plaid = ({ history }) => {
  return <div></div>;
};

export default withRouter(Plaid);
